import { Fold, Lens, Traversal } from "@discovery/prelude/lib/control/lens";
import { _Response2ResponseData } from "./common";
import { _ArticleRichTextContentBlocks, _ArticleRichTextContentEntityMap, } from "./article";
import * as M from "@discovery/prelude/lib/data/maybe";
import { _Col2Data, _Col2Items, _ColAttributes2Component, _ColItem2Article, _ColItem2Channel, _ColItem2Collection, _ColItem2Image, _ColItem2Link, _ColItem2Show, _ColItem2TaxonomyNode, _ColItem2Video, _CollectionResponseGetter, } from "@discovery/sonic-api-ng-optics-gen/lib/collection";
export * from "@discovery/sonic-api-ng-optics-gen/lib/collection";
/**
 * Collection related lenses
 */
export const _ColResponse2Col = Fold.compose(_CollectionResponseGetter, _Response2ResponseData());
export const _Col2Collection = Fold.compose(_Col2Items, _ColItem2Collection);
export const _Col2Channel = Fold.compose(_Col2Items, _ColItem2Channel);
export const _Col2TaxonomyNode = Fold.compose(_Col2Items, _ColItem2TaxonomyNode);
export const _Col2Video = Fold.compose(_Col2Items, _ColItem2Video);
export const _Col2RelImage = Fold.compose(_Col2Items, _ColItem2Image);
export const _Col2Link = Fold.compose(_Col2Items, _ColItem2Link);
export const _Col2Article = Fold.compose(_Col2Items, _ColItem2Article);
export const _Col2ArticleRichTextContentEntityMap = Fold.compose(_Col2Article, _ArticleRichTextContentEntityMap);
export const _Col2ArticleRichTextContentBlocks = Fold.compose(_Col2Article, _ArticleRichTextContentBlocks);
export const _Col2Show = Fold.compose(_Col2Items, _ColItem2Show);
export const _Col2Image = Fold.compose(_Col2Items, _ColItem2Image);
export const _Col2ColDataMetaM = Fold.compose(_Col2Data, Lens.prop("meta"));
export const _Col2ColDataMeta = Fold.compose(_Col2ColDataMetaM, M._Just());
export const _Col2TemplateId = Fold.compose(_ColAttributes2Component, M._Just(), Lens.prop("templateId"));
export const _Col2CustomAttributes = Fold.compose(_ColAttributes2Component, M._Just(), Lens.prop("customAttributes"));
export const _Col2ComponentId = Fold.compose(_ColAttributes2Component, M._Just(), Lens.prop("id"));
export const _ColItemsWithComponentId = (componentId) => Fold.compose(_Col2Collection, Traversal._filteredOn(_Col2ComponentId, (id) => id === componentId));
export const _Col2Id = Fold.compose(_Col2Data, Lens.prop("id"));

